export const seminarData = [
                {
            title: "Charm susceptibilities as a probe of deconfinement from lattice QCD",
            speaker: "Joydeep Chakravarty",
            date: "2026-02-05",
            area: "McGill University"
          },  
        {
            title: "Charm susceptibilities as a probe of deconfinement from lattice QCD",
            speaker: "Prachi Garella",
            date: "2026-01-15",
            area: "University of Houston"
          },  
        {
            title: "On 'Noise-Friendly' Quantum Systems",
            speaker: "Bhavay Tyagi",
            date: "2026-01-13",
            area: "University of Houston"
          },  
        {
            title: "Charm susceptibilities as a probe of deconfinement from lattice QCD",
            speaker: "Shipaz Sharma",
            date: "2025-11-25",
            area: "Technische Universität München"
          },  
        {
            title: "Doubly Separable Spacetimes and Symmetry Constraints on their Self-Gravitating Matter Content",
            speaker: "Prashant Kocherlakota",
            date: "2025-10-09",
            area: "Harvard University"
          },   
        {
            title: "Aspects of black holes in AdS spacetimes",
            speaker: "Kaustubh Singhi",
            date: "2025-09-26",
            area: "ICTS Bengaluru"
          },          
         {
            title: "Journal club: T-duality symmetric formulation of String Theory from the worldsheet perspective",
            speaker: "Franco Pezzella",
            date: "2025-09-23",
            area: "INFN Napoli"
          },
         {
            title: "Hawking radiation from acoustic black holes in relativistic heavy ion collisions and in hydrodynamical flow of electrons",
            speaker: "Ajit M. Srivastava",
            date: "2025-09-18",
            area: "IOP Bhubaneswar"
          }, 
         {
            title: "Is the Scattering Amplitude Analytic in a Field Theory With a Compact Spatial Coordinate?",
            speaker: "Jnan Maharana",
            date: "2025-09-03",
            area: "IOP Bhubaneswar"
          }, 
         {
            title: "Journal club: Conformal field theories in a magnetic field",
            speaker: "Tarun Sharma",
            date: "2025-08-26",
            area: "IIT Delhi"
          }, 
         {
            title: "Journal club: Monopoles, Dirac strings, and Generalized Symmetries",
            speaker: "Madhusudhan Raman",
            date: "2025-08-19",
            area: "Delhi University"
          }, 
         {
            title: "Some aspects of interplay between gravity and quantum information",
            speaker: "Manish Ramchander",
            date: "2025-08-01",
            area: "IMSc Chennai"
          }, 
         {
            title: "Multipartite entanglement monotones",
            speaker: "Abhijit Gadde",
            date: "2025-06-06",
            area: "TIFR Mumbai"
          }, 
         {
            title: "Novel Applications of Power Over Fiber in the DUNE FD-VD Detector",
            speaker: "Biswaranjan Behera",
            date: "2025-04-07",
            area: "South Dakota School of Mines and Technology, USA"
          },  
          {
            title: "Light Nuclei Femtoscopy and Baryon Interactions at RHIC",
            speaker: "Neha Shah",
            date: "2025-03-19",
            area: "IIT Patna"
          },
          {
            title: "Quantum Computing and its Applications to Atoms and Molecules",
            speaker: "Bhanu Pratap Das",
            date: "2025-03-03",
            area: "Centre for Quantum Engineering, Research and Education (TCG CREST), Kolkata and Department of Physics, Tokyo Institute of Technology (currently Institute of Science Tokyo), Japan"
          },
          {
            title: "Using Gravitational Waves to see the Early Universe",
            speaker: "Rishav Roshan",
            date: "2025-02-17",
            area: "University of Southampton, UK"
          },
          {
            title: "QCD-Gravity double-copy in the Regge regime via shockwave collisions",
            speaker: "Himanshu Raj",
            date: "2025-02-12",
            area: "Stony Brook University, USA"
          },
          {
            title: "Journal club: Ergodicity in quantum dynamics",
            speaker: "Amin Nizami",
            date: "2025-02-10",
            area: "Ashoka University"
          },
          {
            title: "Reconciling cosmological tensions with inelastic dark matter and dark radiation",
            speaker: "Satyabrata Mahapatra",
            date: "2025-01-29",
            area: "Sungkyunkwan University, South Korea"
          },
          {
            title: "Feynman diagrams live in conformal families",
            speaker: "Siddharth Prabhu",
            date: "2025-01-27",
            area: "TIFR, Mumbai"
          },
          {
            title: "Physics beyond standard model (A dark matter story)",
            speaker: "Disha Bhatia",
            date: "2025-01-15",
            area: "Instituto de Fisica, Universidade de Sao Paulo, Brazil"
          },
          {
            title: "Imprints of Early Universe Cosmology on Gravitational Waves",
            speaker: "Mudit Rai",
            date: "2025-01-07",
            area: "Texas A&M University, USA"
          }
        ];
